module.exports = __webpack_public_path__ + "static/media/Residential_32.be6703af.jpg";